<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 text-sm">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4">
            <h5 class="text-sm">
              {{ account.name }}
            </h5>
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0 text-right">{{ agency.balance }} &euro;</div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="!agency.can || !agency.can.view || disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
          @click="$emit('agency:view', agency)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    agency: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    ...mapState('entities', {
      account({ accounts }) {
        return accounts.byId[this.agency.account_uuid];
      },
    }),
  },
};
</script>
